import React, { useEffect, useState } from 'react'
import './ProvisionalInterestCalculation.css'
import Radialchart from './RadialChart'
import { fetchProvisionalInterestData, formatToIndianRupees, setActivity, } from '../../Global/Index'
import ClipLoader from 'react-spinners/ClipLoader';
import { ToastContainer, toast } from 'react-toastify';
import { useTheme } from '@mui/material'

const override = {
    display: "block",
    margin: "10% auto",
    marginLeft: '50%'
};

export default function ProvisionalInterestCalculation() {

    const [data, setData] = useState(null);
    const theme = useTheme();


    useEffect(() => {
        setActivity('Provisional Interest Calculation Page');

        fetchProvisionalInterestData().then((datas) => {
            if (datas.response.status === "200") {
                if (datas.response.data) {
                    setData(datas.response.data);
                } else {
                    setData([]);
                }
            } else if (datas.response.status === "419") {
                window.location.href = '/Session-Expired'
            } else if (datas.response.status === "500") {
                toast.error('Something went wrong. Please try again later!')
            } else if (datas.response.status === "503") {
                toast.warn(datas.response.message);
            } else if (datas.response.status == '401') {
                window.location.href = '/'
            }
        }).catch((error) => {
            console.error(error);
        });
    }, []);

    function getFinancialYear() {
        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth() + 1;

        let startYear, endYear;

        if (currentMonth >= 4) {
            startYear = currentYear;
            endYear = currentYear + 1;
        } else {
            startYear = currentYear - 1;
            endYear = currentYear;
        }

        return `${startYear}-${endYear.toString().slice(-2)}`;
    }



    const renderCompoent = () => {
        if (!data || data?.length === 0 || data?.principalAmount === 0 || data?.interestAmount === 0) {
            return <div style={{
                textAlign: 'center',
                padding: '3vh',
                color: 'red'

            }}>
                No Data Found
            </div>
        } else {
            return <div className='provisionalmainconatiner'>
                <div><b>Financial year {getFinancialYear()}</b></div>
                <div className='displayflex'>
                    <div className='displayflex' style={{ width: "100%" }}>
                        <Radialchart data={data} />
                        <div className='marginauto'>
                            <div className='distance'>
                                <p>PRINCIPAL AMOUNT </p>
                                <h4>{formatToIndianRupees(data?.principalAmount)}</h4>
                            </div>
                            <div className='distance'>
                                <p>INTEREST AMOUNT</p>
                                <h4>{formatToIndianRupees(data?.interestAmount)}</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ borderTop: '1px solid lightgray', paddingTop: '2vh' }}>
                    For your reference the PAN of ISFC is mentioned in all certificate/statement along with the sentence as. <br />
                    THIS STATEMENT BEING PROVISIONAL IN NATURE REQUIRES NO AUTHORISATION FROM ISFC<b> ( INCOME TAX PAN: AAACH2702H )</b>
                </div>
            </div>
        }
    }



    return (<>
        <ToastContainer />
        <div className="maincontainer" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
            <h2>Provisional Interest Calculation</h2>
            <div>
                <div className="page-content page-container" id="page-content">
                    {
                        data ? (
                            renderCompoent()
                        ) : (
                            <div className='loader'>
                                <ClipLoader
                                    color={theme.palette.maincolor.light}
                                    loading={true}
                                    cssOverride={override}
                                    size={30}
                                />
                            </div>
                        )
                    }
                </div>

            </div>
        </div>
        <div className='accountsummarymaincontainer'>
        </div>
    </>)
}

